import { render, staticRenderFns } from "./PreNegotiationInstallments.vue?vue&type=template&id=60aca264"
import script from "./PreNegotiationInstallments.vue?vue&type=script&lang=ts"
export * from "./PreNegotiationInstallments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports